
@switch (componentToDisplay$ | async) {
  @case ('DigitalCertificateExpired') {
    <div>
      <app-certificate-expired></app-certificate-expired>
    </div>
  }
  @case ('CommissionSelection') {
    <app-wizard-step-wrapper
      [showStep]="showStep"
      [stepTitle]="stepMetadata.stepName"
      [formGroup]="formStep"
      >
      @if (!!user) {
        <div class="form-step__subheading">
          {{ user.firstName }}, select your commission, along with the county that you are currently
          located in.
        </div>
      }
      <form>
        @if (!isAutoSelectedCommission && availableCommissions$ | async) {
          <app-select-input
            [dataTestId]="'commission-select'"
            [errorMessage]="commissionError"
            [formControlRef]="stateCommission"
            [label]="'Select your commission'"
            [options]="availableCommissions$ | async"
            (selectionChange)="commissionSelected($event.value)"
          ></app-select-input>
        }
        @if (isAutoSelectedCommission) {
          <label for="stateCodes">Your commission</label>
        }
        @if (isAutoSelectedCommission) {
          <p>State: {{ autoSelectedCommissionState }}</p>
        }
        @if (isCommissionSelected && stateCommission.valid) {
          <label for="counties">
            Select the county you are physically located in while performing the signing
          </label>
          @if (isCommissionSelected && stateCommission.valid) {
            <app-select-input
              class="county-select"
              [dataTestId]="'county-select'"
              [errorMessage]="countyError"
              [formControlRef]="counties"
              [label]="'County'"
              [options]="availableCounties$ | async"
              (selectionChange)="countySelected($event)"
            ></app-select-input>
          }
        }
        @if (isCommissionSelected && stateCommission.valid) {
          @if (selectedCommission$ | async; as selectedCommission) {
            <div
              class="commission"
              data-private
              >
              <div class="commission__detail">
                <h4 class="commission__detail--heading">Name On Commission</h4>
                <p class="commission__detail--value">{{ selectedCommission.name }}</p>
              </div>
              <div class="commission__detail">
                <h4 class="commission__detail--heading">Commission Expiration</h4>
                <p class="commission__detail--value">{{ selectedCommission.expiresOn | date: 'longDate' }}</p>
              </div>
              <div class="commission__detail">
                <h4 class="commission__detail--heading">Commission County</h4>
                <p class="commission__detail--value">{{ selectedCommission.county }}</p>
              </div>
              <div class="commission__detail">
                <h4 class="commission__detail--heading">Commission Number</h4>
                <p class="commission__detail--value">{{ selectedCommission.number }}</p>
              </div>
              <div class="commission__detail">
                <h4 class="commission__detail--heading">Stamp On File</h4>
                <img
                  src="data:image/png;base64,{{ selectedCommission.stamp }}"
                  alt="Notary stamp for selected commission"
                  />
                </div>
              </div>
            }
            <app-scrollable-text-box
              [contentMarkup]="(selectedCommissionConsent$ | async)?.presentText"
              >
            </app-scrollable-text-box>
            <p class="form-step__text">
              By checking “I Agree” below, I am affirming and agreeing to the requirements of the
              above Signing Agent Acknowledgment and that I am located in the above selected county at
              the time of performing this online electronic signing.
            </p>
            <mat-checkbox
              class="consent__checkbox"
              data-testid="commission-agreement-checkbox"
              [formControl]="commissionAgreementCheckbox"
              (change)="clearFailureText()">
              {{ consentText }}
            </mat-checkbox>
            @if (submissionFailure) {
              <p class="consent-error-message" data-testid="consent-error">
                {{ consentErrorText }}
              </p>
            }
          }
        </form>
        @if (
          stateCommission.errors?.expiredCommission &&
          (stateCommission.dirty || stateCommission.touched)
          ) {
          <app-expired-commission
          ></app-expired-commission>
        }
        <app-button-container>
          <app-button [dataTestId]="'next-button-commission'" type="primary" (click)="goToNextStep()">
            Next
          </app-button>
        </app-button-container>
      </app-wizard-step-wrapper>
    }
  }
